import { Link } from 'react-router-dom';
import { PRODUCT_URL, STORE_URL } from '../constants';
import { Shield, Truck, RefreshCw } from 'lucide-react';

export default function Footer() {
  const cols = [
  {
    title: 'About',
    links: [
    { label: 'Our Story', to: '/about' },
    { label: 'Ingredients', to: '/#ingredients' },
    { label: 'Contact Us', to: '/contact' }]
  },
  {
    title: 'Learn',
    links: [
    { label: 'Blog', to: '/blog' },
    { label: 'How It Works', href: '/#how-it-works' },
    { label: 'FAQ', href: '/#faq' }]
  },
  {
    title: 'Support',
    links: [
    { label: 'Shipping Info', to: '/shipping' },
    { label: 'Returns', to: '/shipping' },
    { label: 'FAQ', href: '/#faq' }]
  },
  {
    title: 'Legal',
    links: [
    { label: 'Privacy Policy', to: '/privacy' },
    { label: 'Terms of Service', to: '/terms' },
    { label: 'Shipping Policy', to: '/shipping' }]
  }];


  const trustItems = [
  { icon: Shield, label: 'Premium Quality' },
  { icon: Truck, label: 'Free UK Delivery Over £30' },
  { icon: RefreshCw, label: '30-Day Returns' }];


  return (
    <footer data-testid="footer" style={{ backgroundColor: '#FFFFFF', borderTop: '1px solid #E2E8F0' }}>
      {/* Trust strip */}
      <div style={{ borderBottom: '1px solid #E2E8F0', padding: '18px 0', backgroundColor: '#F7F7F5' }}>
        <div className="max-w-7xl mx-auto px-6 md:px-12 flex flex-col md:flex-row items-center justify-center gap-6 md:gap-14">
          {trustItems.map(({ icon: Icon, label }) =>
          <div key={label} className="flex items-center gap-2" style={{ color: '#64748B', fontSize: '0.72rem', letterSpacing: '0.15em', textTransform: 'uppercase', fontFamily: 'Manrope, sans-serif', fontWeight: 600 }}>
              <Icon size={14} style={{ color: '#1B3D7E' }} strokeWidth={1.5} />
              {label}
            </div>
          )}
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 md:px-12 py-14">
        <div className="grid grid-cols-1 md:grid-cols-6 gap-10">
          {/* Brand */}
          <div className="md:col-span-1">
            <Link to="/" style={{ fontFamily: 'Outfit, sans-serif', fontWeight: 800, fontSize: '1.4rem', letterSpacing: '0.25em', color: '#0D1A2E', textDecoration: 'none', textTransform: 'uppercase' }}>
              RE<span style={{ color: '#1B3D7E' }}>LOAD</span>
            </Link>
            <p style={{ fontFamily: 'Manrope, sans-serif', fontSize: '0.82rem', color: '#64748B', lineHeight: 1.75, marginTop: '12px' }} className="!text-[#64748B]">Premium plant-based formula designed to support male reproductive health and performance

            </p>
            <div className="blue-divider mt-4"></div>
          </div>

          {/* Links */}
          {cols.map((col) =>
          <div key={col.title}>
              <h4 style={{ fontFamily: 'Outfit, sans-serif', fontSize: '0.68rem', letterSpacing: '0.25em', textTransform: 'uppercase', color: '#1B3D7E', fontWeight: 700, marginBottom: '14px' }}>
                {col.title}
              </h4>
              <ul style={{ listStyle: 'none', display: 'flex', flexDirection: 'column', gap: '10px' }}>
                {col.links.map((link) =>
              <li key={link.label}>
                    {link.external ?
                <a href={link.href} target="_blank" rel="noopener noreferrer" style={{ fontFamily: 'Manrope, sans-serif', fontSize: '0.84rem', color: '#64748B', textDecoration: 'none', transition: 'color 0.2s' }} onMouseEnter={(e) => e.target.style.color = '#1B3D7E'} onMouseLeave={(e) => e.target.style.color = '#64748B'}>
                        {link.label}
                      </a> :
                link.to ?
                <Link to={link.to} style={{ fontFamily: 'Manrope, sans-serif', fontSize: '0.84rem', color: '#64748B', textDecoration: 'none', transition: 'color 0.2s' }} onMouseEnter={(e) => e.target.style.color = '#1B3D7E'} onMouseLeave={(e) => e.target.style.color = '#64748B'}>
                        {link.label}
                      </Link> :

                <a href={link.href} style={{ fontFamily: 'Manrope, sans-serif', fontSize: '0.84rem', color: '#64748B', textDecoration: 'none' }}>{link.label}</a>
                }
                  </li>
              )}
              </ul>
            </div>
          )}
        </div>

        <div className="mt-10 pt-6 flex flex-col md:flex-row items-center justify-between gap-3" style={{ borderTop: '1px solid #E2E8F0' }}>
          <p style={{ fontFamily: 'Manrope, sans-serif', fontSize: '0.75rem', color: '#94A3B8' }}>
            &copy; {new Date().getFullYear()} RELOAD by Reload Nutrition. All rights reserved.
          </p>
          <p style={{ fontFamily: 'Manrope, sans-serif', fontSize: '0.72rem', color: '#94A3B8', textAlign: 'center' }}>
            These statements have not been evaluated by the MHRA. Not intended to diagnose, treat, cure, or prevent any disease.
          </p>
        </div>
      </div>
    </footer>);

}